// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file annealing/compute/v1/resources.proto (package annealing.compute.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ClusterState, MachineState } from "./enums_pb";
import { file_annealing_compute_v1_enums } from "./enums_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file annealing/compute/v1/resources.proto.
 */
export const file_annealing_compute_v1_resources: GenFile = /*@__PURE__*/
  fileDesc("CiRhbm5lYWxpbmcvY29tcHV0ZS92MS9yZXNvdXJjZXMucHJvdG8SFGFubmVhbGluZy5jb21wdXRlLnYxItsCCgdNYWNoaW5lEgwKBG5hbWUYASABKAkSMQoFc3RhdGUYAiABKA4yIi5hbm5lYWxpbmcuY29tcHV0ZS52MS5NYWNoaW5lU3RhdGUSNQoLc3lzdGVtX2luZm8YAyABKAsyIC5hbm5lYWxpbmcuY29tcHV0ZS52MS5TeXN0ZW1JbmZvEi8KC2NyZWF0ZV90aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgt1cGRhdGVfdGltZRgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLZGVsZXRlX3RpbWUYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wOkXqQUIKGWFwaS5hbm5lYWxpbmcuZGV2L01hY2hpbmUSJXByb2plY3RzL3twcm9qZWN0fS9tYWNoaW5lcy97bWFjaGluZX0i/QEKClN5c3RlbUluZm8SQwoQb3BlcmF0aW5nX3N5c3RlbRgBIAEoCzIpLmFubmVhbGluZy5jb21wdXRlLnYxLk9wZXJhdGluZ1N5c3RlbUluZm8SMAoGa2VybmVsGAIgASgLMiAuYW5uZWFsaW5nLmNvbXB1dGUudjEuS2VybmVsSW5mbxI0CghoYXJkd2FyZRgDIAEoCzIiLmFubmVhbGluZy5jb21wdXRlLnYxLkhhcmR3YXJlSW5mbxJCChJuZXR3b3JrX2ludGVyZmFjZXMYBCADKAsyJi5hbm5lYWxpbmcuY29tcHV0ZS52MS5OZXR3b3JrSW50ZXJmYWNlIjUKE09wZXJhdGluZ1N5c3RlbUluZm8SCgoCaWQYASABKAkSEgoKdmVyc2lvbl9pZBgCIAEoCSJBCgpLZXJuZWxJbmZvEgwKBG5hbWUYASABKAkSDwoHcmVsZWFzZRgCIAEoCRIUCgxhcmNoaXRlY3R1cmUYAyABKAkiPgoMSGFyZHdhcmVJbmZvEhIKCnZjcHVfY291bnQYASABKAUSGgoSdG90YWxfbWVtb3J5X2J5dGVzGAIgASgDIrEBChBOZXR3b3JrSW50ZXJmYWNlEgwKBG5hbWUYASABKAkSEwoLbWFjX2FkZHJlc3MYAiABKAkSPAoOaXB2NF9hZGRyZXNzZXMYAyADKAsyJC5hbm5lYWxpbmcuY29tcHV0ZS52MS5OZXR3b3JrQWRkcmVzcxI8Cg5pcHY2X2FkZHJlc3NlcxgEIAMoCzIkLmFubmVhbGluZy5jb21wdXRlLnYxLk5ldHdvcmtBZGRyZXNzIjUKDk5ldHdvcmtBZGRyZXNzEhIKCmlwX2FkZHJlc3MYASABKAkSDwoHcHJpbWFyeRgCIAEoCCLKBAoHQ2x1c3RlchIMCgRuYW1lGAEgASgJEhMKC2Rlc2NyaXB0aW9uGAIgASgJEgsKA3VpZBgDIAEoCRIQCghlbmRwb2ludBgEIAEoCRIPCgd2ZXJzaW9uGAUgASgJEh0KFWNlcnRpZmljYXRlX2F1dGhvcml0eRgGIAEoCRIxCgVzdGF0ZRgHIAEoDjIiLmFubmVhbGluZy5jb21wdXRlLnYxLkNsdXN0ZXJTdGF0ZRI7CgpuZXR3b3JraW5nGAggASgLMicuYW5uZWFsaW5nLmNvbXB1dGUudjEuQ2x1c3Rlck5ldHdvcmtpbmcSQAoNY29udHJvbF9wbGFuZRgJIAEoCzIpLmFubmVhbGluZy5jb21wdXRlLnYxLkNsdXN0ZXJDb250cm9sUGxhbmUSQQoNYXV0aG9yaXphdGlvbhgKIAEoCzIqLmFubmVhbGluZy5jb21wdXRlLnYxLkNsdXN0ZXJBdXRob3JpemF0aW9uEi8KC2NyZWF0ZV90aW1lGAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgt1cGRhdGVfdGltZRgMIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLZGVsZXRlX3RpbWUYDSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wOkXqQUIKGWFwaS5hbm5lYWxpbmcuZGV2L0NsdXN0ZXISJXByb2plY3RzL3twcm9qZWN0fS9jbHVzdGVycy97Y2x1c3Rlcn0iUwoRQ2x1c3Rlck5ldHdvcmtpbmcSHAoUcG9kX2lwdjRfY2lkcl9ibG9ja3MYASADKAkSIAoYc2VydmljZV9pcHY0X2NpZHJfYmxvY2tzGAIgAygJInEKE0NsdXN0ZXJDb250cm9sUGxhbmUSEAoIbWFjaGluZXMYASADKAkSSAoLbm9kZV9jb25maWcYAiABKAsyMy5hbm5lYWxpbmcuY29tcHV0ZS52MS5DbHVzdGVyQ29udHJvbFBsYW5lTm9kZUNvbmZpZyKtAgodQ2x1c3RlckNvbnRyb2xQbGFuZU5vZGVDb25maWcSFQoNcmVnaXN0ZXJfbm9kZRgBIAEoCBJEChNtYXhfcG9kc19jb25zdHJhaW50GAIgASgLMicuYW5uZWFsaW5nLmNvbXB1dGUudjEuTWF4UG9kc0NvbnN0cmFpbnQSLwoGdGFpbnRzGAMgAygLMh8uYW5uZWFsaW5nLmNvbXB1dGUudjEuTm9kZVRhaW50Ek8KBmxhYmVscxgEIAMoCzI/LmFubmVhbGluZy5jb21wdXRlLnYxLkNsdXN0ZXJDb250cm9sUGxhbmVOb2RlQ29uZmlnLkxhYmVsc0VudHJ5Gi0KC0xhYmVsc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEiLgoRTWF4UG9kc0NvbnN0cmFpbnQSGQoRbWF4X3BvZHNfcGVyX25vZGUYASABKAMiNwoJTm9kZVRhaW50EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCRIOCgZlZmZlY3QYAyABKAkiKwoUQ2x1c3RlckF1dGhvcml6YXRpb24SEwoLYWRtaW5fdXNlcnMYASADKAki3QEKEU9wZXJhdGlvbk1ldGFkYXRhEi8KC2NyZWF0ZV90aW1lGAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghlbmRfdGltZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDgoGdGFyZ2V0GAMgASgJEhUKDXN0YXR1c19kZXRhaWwYBCABKAkSFAoMZXJyb3JfZGV0YWlsGAUgASgJEgwKBHZlcmIYBiABKAkSHgoWcmVxdWVzdGVkX2NhbmNlbGxhdGlvbhgHIAEoCELWAQoYY29tLmFubmVhbGluZy5jb21wdXRlLnYxQg5SZXNvdXJjZXNQcm90b1ABWjhnaXRsYWIuY29tL2dyb3Nza3VyL2FubmVhbGluZy9wcm90by9hbm5lYWxpbmcvY29tcHV0ZS92MaICA0FDWKoCFEFubmVhbGluZy5Db21wdXRlLlYxygIUQW5uZWFsaW5nXENvbXB1dGVcVjHiAiBBbm5lYWxpbmdcQ29tcHV0ZVxWMVxHUEJNZXRhZGF0YeoCFkFubmVhbGluZzo6Q29tcHV0ZTo6VjFiBnByb3RvMw", [file_google_api_resource, file_google_protobuf_timestamp, file_annealing_compute_v1_enums]);

/**
 * @generated from message annealing.compute.v1.Machine
 */
export type Machine = Message<"annealing.compute.v1.Machine"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: annealing.compute.v1.MachineState state = 2;
   */
  state: MachineState;

  /**
   * @generated from field: annealing.compute.v1.SystemInfo system_info = 3;
   */
  systemInfo?: SystemInfo;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp delete_time = 6;
   */
  deleteTime?: Timestamp;
};

/**
 * Describes the message annealing.compute.v1.Machine.
 * Use `create(MachineSchema)` to create a new message.
 */
export const MachineSchema: GenMessage<Machine> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 0);

/**
 * @generated from message annealing.compute.v1.SystemInfo
 */
export type SystemInfo = Message<"annealing.compute.v1.SystemInfo"> & {
  /**
   * @generated from field: annealing.compute.v1.OperatingSystemInfo operating_system = 1;
   */
  operatingSystem?: OperatingSystemInfo;

  /**
   * @generated from field: annealing.compute.v1.KernelInfo kernel = 2;
   */
  kernel?: KernelInfo;

  /**
   * @generated from field: annealing.compute.v1.HardwareInfo hardware = 3;
   */
  hardware?: HardwareInfo;

  /**
   * @generated from field: repeated annealing.compute.v1.NetworkInterface network_interfaces = 4;
   */
  networkInterfaces: NetworkInterface[];
};

/**
 * Describes the message annealing.compute.v1.SystemInfo.
 * Use `create(SystemInfoSchema)` to create a new message.
 */
export const SystemInfoSchema: GenMessage<SystemInfo> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 1);

/**
 * @generated from message annealing.compute.v1.OperatingSystemInfo
 */
export type OperatingSystemInfo = Message<"annealing.compute.v1.OperatingSystemInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string version_id = 2;
   */
  versionId: string;
};

/**
 * Describes the message annealing.compute.v1.OperatingSystemInfo.
 * Use `create(OperatingSystemInfoSchema)` to create a new message.
 */
export const OperatingSystemInfoSchema: GenMessage<OperatingSystemInfo> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 2);

/**
 * @generated from message annealing.compute.v1.KernelInfo
 */
export type KernelInfo = Message<"annealing.compute.v1.KernelInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string release = 2;
   */
  release: string;

  /**
   * @generated from field: string architecture = 3;
   */
  architecture: string;
};

/**
 * Describes the message annealing.compute.v1.KernelInfo.
 * Use `create(KernelInfoSchema)` to create a new message.
 */
export const KernelInfoSchema: GenMessage<KernelInfo> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 3);

/**
 * @generated from message annealing.compute.v1.HardwareInfo
 */
export type HardwareInfo = Message<"annealing.compute.v1.HardwareInfo"> & {
  /**
   * @generated from field: int32 vcpu_count = 1;
   */
  vcpuCount: number;

  /**
   * @generated from field: int64 total_memory_bytes = 2;
   */
  totalMemoryBytes: bigint;
};

/**
 * Describes the message annealing.compute.v1.HardwareInfo.
 * Use `create(HardwareInfoSchema)` to create a new message.
 */
export const HardwareInfoSchema: GenMessage<HardwareInfo> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 4);

/**
 * @generated from message annealing.compute.v1.NetworkInterface
 */
export type NetworkInterface = Message<"annealing.compute.v1.NetworkInterface"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string mac_address = 2;
   */
  macAddress: string;

  /**
   * @generated from field: repeated annealing.compute.v1.NetworkAddress ipv4_addresses = 3;
   */
  ipv4Addresses: NetworkAddress[];

  /**
   * @generated from field: repeated annealing.compute.v1.NetworkAddress ipv6_addresses = 4;
   */
  ipv6Addresses: NetworkAddress[];
};

/**
 * Describes the message annealing.compute.v1.NetworkInterface.
 * Use `create(NetworkInterfaceSchema)` to create a new message.
 */
export const NetworkInterfaceSchema: GenMessage<NetworkInterface> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 5);

/**
 * @generated from message annealing.compute.v1.NetworkAddress
 */
export type NetworkAddress = Message<"annealing.compute.v1.NetworkAddress"> & {
  /**
   * @generated from field: string ip_address = 1;
   */
  ipAddress: string;

  /**
   * @generated from field: bool primary = 2;
   */
  primary: boolean;
};

/**
 * Describes the message annealing.compute.v1.NetworkAddress.
 * Use `create(NetworkAddressSchema)` to create a new message.
 */
export const NetworkAddressSchema: GenMessage<NetworkAddress> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 6);

/**
 * @generated from message annealing.compute.v1.Cluster
 */
export type Cluster = Message<"annealing.compute.v1.Cluster"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string uid = 3;
   */
  uid: string;

  /**
   * @generated from field: string endpoint = 4;
   */
  endpoint: string;

  /**
   * @generated from field: string version = 5;
   */
  version: string;

  /**
   * @generated from field: string certificate_authority = 6;
   */
  certificateAuthority: string;

  /**
   * @generated from field: annealing.compute.v1.ClusterState state = 7;
   */
  state: ClusterState;

  /**
   * @generated from field: annealing.compute.v1.ClusterNetworking networking = 8;
   */
  networking?: ClusterNetworking;

  /**
   * @generated from field: annealing.compute.v1.ClusterControlPlane control_plane = 9;
   */
  controlPlane?: ClusterControlPlane;

  /**
   * @generated from field: annealing.compute.v1.ClusterAuthorization authorization = 10;
   */
  authorization?: ClusterAuthorization;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 11;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 12;
   */
  updateTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp delete_time = 13;
   */
  deleteTime?: Timestamp;
};

/**
 * Describes the message annealing.compute.v1.Cluster.
 * Use `create(ClusterSchema)` to create a new message.
 */
export const ClusterSchema: GenMessage<Cluster> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 7);

/**
 * @generated from message annealing.compute.v1.ClusterNetworking
 */
export type ClusterNetworking = Message<"annealing.compute.v1.ClusterNetworking"> & {
  /**
   * @generated from field: repeated string pod_ipv4_cidr_blocks = 1;
   */
  podIpv4CidrBlocks: string[];

  /**
   * @generated from field: repeated string service_ipv4_cidr_blocks = 2;
   */
  serviceIpv4CidrBlocks: string[];
};

/**
 * Describes the message annealing.compute.v1.ClusterNetworking.
 * Use `create(ClusterNetworkingSchema)` to create a new message.
 */
export const ClusterNetworkingSchema: GenMessage<ClusterNetworking> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 8);

/**
 * @generated from message annealing.compute.v1.ClusterControlPlane
 */
export type ClusterControlPlane = Message<"annealing.compute.v1.ClusterControlPlane"> & {
  /**
   * @generated from field: repeated string machines = 1;
   */
  machines: string[];

  /**
   * @generated from field: annealing.compute.v1.ClusterControlPlaneNodeConfig node_config = 2;
   */
  nodeConfig?: ClusterControlPlaneNodeConfig;
};

/**
 * Describes the message annealing.compute.v1.ClusterControlPlane.
 * Use `create(ClusterControlPlaneSchema)` to create a new message.
 */
export const ClusterControlPlaneSchema: GenMessage<ClusterControlPlane> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 9);

/**
 * @generated from message annealing.compute.v1.ClusterControlPlaneNodeConfig
 */
export type ClusterControlPlaneNodeConfig = Message<"annealing.compute.v1.ClusterControlPlaneNodeConfig"> & {
  /**
   * @generated from field: bool register_node = 1;
   */
  registerNode: boolean;

  /**
   * @generated from field: annealing.compute.v1.MaxPodsConstraint max_pods_constraint = 2;
   */
  maxPodsConstraint?: MaxPodsConstraint;

  /**
   * @generated from field: repeated annealing.compute.v1.NodeTaint taints = 3;
   */
  taints: NodeTaint[];

  /**
   * @generated from field: map<string, string> labels = 4;
   */
  labels: { [key: string]: string };
};

/**
 * Describes the message annealing.compute.v1.ClusterControlPlaneNodeConfig.
 * Use `create(ClusterControlPlaneNodeConfigSchema)` to create a new message.
 */
export const ClusterControlPlaneNodeConfigSchema: GenMessage<ClusterControlPlaneNodeConfig> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 10);

/**
 * @generated from message annealing.compute.v1.MaxPodsConstraint
 */
export type MaxPodsConstraint = Message<"annealing.compute.v1.MaxPodsConstraint"> & {
  /**
   * @generated from field: int64 max_pods_per_node = 1;
   */
  maxPodsPerNode: bigint;
};

/**
 * Describes the message annealing.compute.v1.MaxPodsConstraint.
 * Use `create(MaxPodsConstraintSchema)` to create a new message.
 */
export const MaxPodsConstraintSchema: GenMessage<MaxPodsConstraint> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 11);

/**
 * @generated from message annealing.compute.v1.NodeTaint
 */
export type NodeTaint = Message<"annealing.compute.v1.NodeTaint"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: string effect = 3;
   */
  effect: string;
};

/**
 * Describes the message annealing.compute.v1.NodeTaint.
 * Use `create(NodeTaintSchema)` to create a new message.
 */
export const NodeTaintSchema: GenMessage<NodeTaint> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 12);

/**
 * @generated from message annealing.compute.v1.ClusterAuthorization
 */
export type ClusterAuthorization = Message<"annealing.compute.v1.ClusterAuthorization"> & {
  /**
   * @generated from field: repeated string admin_users = 1;
   */
  adminUsers: string[];
};

/**
 * Describes the message annealing.compute.v1.ClusterAuthorization.
 * Use `create(ClusterAuthorizationSchema)` to create a new message.
 */
export const ClusterAuthorizationSchema: GenMessage<ClusterAuthorization> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 13);

/**
 * @generated from message annealing.compute.v1.OperationMetadata
 */
export type OperationMetadata = Message<"annealing.compute.v1.OperationMetadata"> & {
  /**
   * @generated from field: google.protobuf.Timestamp create_time = 1;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * @generated from field: string status_detail = 4;
   */
  statusDetail: string;

  /**
   * @generated from field: string error_detail = 5;
   */
  errorDetail: string;

  /**
   * @generated from field: string verb = 6;
   */
  verb: string;

  /**
   * @generated from field: bool requested_cancellation = 7;
   */
  requestedCancellation: boolean;
};

/**
 * Describes the message annealing.compute.v1.OperationMetadata.
 * Use `create(OperationMetadataSchema)` to create a new message.
 */
export const OperationMetadataSchema: GenMessage<OperationMetadata> = /*@__PURE__*/
  messageDesc(file_annealing_compute_v1_resources, 14);

